import { getRouteParams } from './getRouteParams';
export const getQueryParams = () => {
  return getRouteParams().queryParams;
};